import { render, staticRenderFns } from "./PostVideo.vue?vue&type=template&id=428d330e&"
import script from "./PostVideo.vue?vue&type=script&lang=js&"
export * from "./PostVideo.vue?vue&type=script&lang=js&"
import style0 from "./PostVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports